import {ExpandableOptionType, OptionsSchemeItem} from './types';

export const findFocusedAction = (optionScheme: OptionsSchemeItem[], focusedIndex: number) => {
    let focusedOption = null;

    for (let i = 0; i < optionScheme.length; i++) {
        const option = optionScheme[i];
        const optionIndex = option.data.index;

        if (optionIndex === focusedIndex) {
            focusedOption = option;
            break;
        }

        const additionalOptions = option.data?.additionalOptions;

        if (additionalOptions && option.data?.showOptions) {
            for (let j = 0; j < additionalOptions.length; j++) {
                const additionalOption = additionalOptions[j];
                const additionalOptionIndex = additionalOption.data.index;

                if (additionalOptionIndex === focusedIndex) {
                    focusedOption = additionalOption;
                    break;
                }
            }
        }
    }

    return focusedOption;
};

export const isIndeterminated = (
    options: Array<ExpandableOptionType>,
    values?: Array<string | number>
) => {
    return options.some(item => values?.includes(item.value as string | number));
};

export const isExpandableItemChecked = (
    options: Array<ExpandableOptionType> = [],
    values: Array<string | number> = []
) => {
    if (options.length > 0 && options.length <= values.length) {
        return options.every(option => values.includes(option.value as string | number));
    }
    return false;
};
